import type { SectionComponentProps } from "./registry";

type QuoteData = {
  text: string;
  author?: string;
  source?: string;
};

export function QuoteSection({ data }: SectionComponentProps) {
  const quote = data as QuoteData;
  if (!quote?.text) return null;

  return (
    <blockquote className="border-s-4 border-violet-500/50 ps-4 py-1">
      <p className="text-sm text-foreground italic leading-relaxed">
        "{quote.text}"
      </p>
      {(quote.author || quote.source) && (
        <footer className="mt-2 text-xs text-muted-foreground">
          {quote.author && <span className="font-medium text-foreground">— {quote.author}</span>}
          {quote.source && <span>, {quote.source}</span>}
        </footer>
      )}
    </blockquote>
  );
}
